import '../../../../modules/system/assets/js/framework';
import $ from 'jquery';

export class Api {

    static removeProductFromCart(productId, callback) {
        $.request('onRemoveFromCart', {
            data: {'id': productId},
            complete: () => {
                $('[data-cart-item]').length == 0 ?  window.location.href = '/cart' : null;
                callback();
            }
        })
    }

    static addProductToCart(data) {
        $.request('onAddToCart', {
            data: { 'data': data },
            complete: () => { }
        })
    }

    static addProductToFavorite(productId) {
        $.request('onAddToFavorites', {
            data: { 'id': productId },
            success: () => { }
        })
    }

    static removeProductFromFavorite(productId) {
        $.request('onRemoveFromFavorites', {
            data: { 'id': productId },
            success: () => { }
        })
    }
}
